<template>
  <v-container
    :class="'grey ' + isAlternate ? 'lighten-2' : 'lighten-3'"
    ref="content_card"
    id="content_card"
  >
    <v-row class="mh-main-row">
      <v-col cols="12" class="pt-0 mh-main-col">
        <main-filters
          :reportRequest="reportRequest"
          :page="pageData"
          @cubeDataClick="cubeData"
          @stopCalc="stopCube"
          :show-hourly="false"
          @calendarRange="(val) => (this.range = val)"
          :aggregate-visible="false"
          @cities="(val) => (this.cities = val)"
          @tvList="(val) => (this.channels = val)"
          @sources="(val) => (this.sources = val)"
          :loading="chart_loading"
          startIndicator="Share"
          :maxChannels="12"
        >
        </main-filters>
        <v-card
          class="stickySliderBlock"
          elevation="10"
          v-if="chart_loading === false"
        >
          <v-row class="ml-2 mr-2">
            <v-col class="col-12 col-sm-12 col-md-12 col-lg-8">
              <div id="comparison_slider" :style="'width: 100%'"></div>
              <a
                href="#"
                class="restoreSliderVals"
                @click.prevent="restoreSliderVals"
                >Восстановить значения по умолчанию</a
              >
            </v-col>
            <v-col
              class="col-9 col-sm-6 col-md-5 col-lg-3 mt-0"
              style="padding-top: 6px"
            >
              <div
                style="
                  float: left;
                  margin-right: 20px;
                  height: 30px;
                  line-height: 30px;
                  color: #1e1e21;
                "
              >
                Подробные&nbsp;значения
              </div>
              <v-switch
                style="margin-top: 0; height: 30px"
                v-model="showValues"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row
            class="ml-2 mr-2 mt-0 pt-0"
            v-if="
              $store.getters.StateUser.settings.compare_period_tip_closed != 1
            "
          >
            <v-col cols="12">
              <div class="chartHelper">
                <v-icon small color="#FFA91B" class="pr-1"
                  >mdi-lightbulb</v-icon
                >
                Настройте тепловое окрашивание блока телепередачи в зависимости
                от среднего значения показателя за выбранный период.
                <v-icon class="ml-2" small @click="hideTip">mdi-close</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <v-card
          outlined
          class="mt-6"
          v-if="chart_loading === false"
          id="highcharts_png"
        >
          <v-card-title
            class="text-lg-h5 text-md-h6 justify-space-between pb-0 flex-row"
          >
            {{ chartTitle }}
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="secondary"
                  elevation="0"
                  class="mh-secondary-border ml-2"
                  style="text-transform: none !important"
                  v-bind="attrs"
                  v-on="on"
                  data-html2canvas-ignore
                >
                  <v-icon small>mdi-download</v-icon>Скачать</v-btn
                >
              </template>
              <v-list dense>
                <v-list-item dense link @click="toExcel" v-if="!isAlternate">
                  <v-list-item-title>Таблица (xlsx)</v-list-item-title>
                </v-list-item>
                <v-list-item dense link @click="saveChartToPng">
                  <v-list-item-title>Изображение (png)</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title>
          <v-card-text>
            <v-col class="ml-0 pl-0">
              <div class="chartTitle">{{ subtitle }}</div>
              <div id="highchartDiv" :style="contentBlockStyles">
                <div class="airRowTimes" style="left: 0">
                  <div class="airRowTitle">Время</div>
                  <div
                    v-for="(category, index) in data.charts[0].categories"
                    :key="index"
                    class="airRowTime"
                    :class="index == 0 && indicator == 'All' && 'first'"
                    :style="timeColumnStyles"
                  >
                    {{ drawTimeValues(category) }}
                  </div>
                </div>
                <horizontal-scrollbar
                  classes="my-scrollbar"
                  ref="contentScrollbar"
                >
                  <div
                    class="airRowsContent"
                    :style="mainColumnStyles"
                    v-if="indicator !== 'All'"
                  >
                    <div
                      v-for="(chart, column) in data.charts"
                      class="airRowData"
                      :key="column"
                      :style="dataColumnStyles"
                    >
                      <div class="airRowProgs" :style="progsColumnStyles">
                        <div class="airRowTitle">
                          {{ drawRowDate(chart.series[0].subtitle) }}
                        </div>
                        <div
                          v-for="(prog, row) in chart.programs"
                          :key="row"
                          :style="getProgStyle(prog, row, column)"
                          class="airProgData"
                        >
                          <v-menu :nudge-width="300" offset-x>
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on">
                                <div
                                  :style="`max-height: ${prog.height - 7}px;`"
                                >
                                  <b>{{
                                    prog.height >= cellHeight ? prog.y : ""
                                  }}</b>
                                  <br v-if="prog.height >= cellHeight" />
                                  {{
                                    prog.height >= cellHeight
                                      ? prog.prog.name
                                      : ""
                                  }}
                                </div>
                              </div>
                            </template>
                            <v-card>
                              <v-card-text>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    class="popupBlockTitle mb-0 pb-0"
                                    >Название</v-col
                                  >
                                </v-row>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    class="popupBlockContent mt-0 pt-0 mb-4 pb-0"
                                    >{{ prog.prog.name }}</v-col
                                  >
                                </v-row>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    class="popupBlockContent mt-0 pt-0 mb-4 pb-0 font-weight-regular"
                                    >{{ drawProgDates(prog) }}</v-col
                                  >
                                </v-row>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    class="popupBlockTitle mt-0 pt-0 mb-0 pb-1"
                                    >{{ chartTitle }}</v-col
                                  >
                                </v-row>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    class="popupBlockContentBig mt-0 pt-0 mb-4 pb-0"
                                    >{{ prog.y }}</v-col
                                  >
                                </v-row>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    class="popupBlockTitle mt-0 pt-0 mb-0 pb-0"
                                    >Канал</v-col
                                  >
                                </v-row>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    class="popupBlockContent mt-0 pt-0 mb-4 pb-0"
                                    >{{ chart.series[0].name }}</v-col
                                  >
                                </v-row>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    class="popupBlockTitle mt-0 pt-0 mb-0 pb-0"
                                    >Описание программы</v-col
                                  >
                                </v-row>
                                <v-row class="mt-0 pt-0">
                                  <v-col
                                    cols="12"
                                    class="popupBlockContentSmall"
                                  >
                                    {{ prog.prog.programDesc }}
                                    <br />
                                    {{ prog.prog.programTags }}
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-menu>
                        </div>
                      </div>

                      <div class="airRowValues" v-if="showValues">
                        <div class="airRowTitle">
                          <div
                            style="
                              border-left: 1px solid gray;
                              width: 100%;
                              margin-top: 5px;
                              height: 17px;
                            "
                          >
                            <div style="text-align: center; line-height: 17px">
                              {{
                                chartTitle
                                  .replace("Аудитория,", "Ауд.")
                                  .replace("тыс. чел.", "тыс.")
                              }}
                            </div>
                          </div>
                        </div>
                        <div
                          v-for="(value, chartId) in chart.series[0].data"
                          :style="`height: ${cellHeight}px; line-height: ${cellHeight}px; position: relative;`"
                          :key="chartId"
                        >
                          <img
                            v-if="value.y"
                            :src="require('@/assets/share.png')"
                            :style="`position: absolute; left: ${(left =
                              -100 +
                              (value.y / chart.series[0].maxY) * 97)}px;`"
                          />
                          <div style="position: absolute; right: 0">
                            {{ value.y }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="airRowsCombined"
                    :style="mainColumnStyles"
                    v-if="indicator === 'All'"
                  >
                    <div
                      v-for="(chart, column) in data.charts"
                      class="airRowData"
                      :key="column"
                      :style="dataColumnStyles"
                    >
                      <div class="airRowCombined">
                        <div class="airRowTitle">
                          {{ drawRowDate(chart.series[0].subtitle) }}
                        </div>
                        <div class="airRowSubtitle">
                          <div>Ауд. тыс.</div>
                          <div>Рейтинг</div>
                          <div>Доля</div>
                        </div>

                        <div
                          v-for="(value, row) in chart.series[0].data"
                          :key="row"
                          class="airRowCombinedBlock"
                          :class="row == 0 && 'first'"
                          :style="getValuesStyles(value, row)"
                        >
                          <div class="airRowCombinedCell">
                            {{ value.y_aud }}
                          </div>
                          <div class="airRowCombinedCell">
                            {{ value.y_tvr }}
                          </div>
                          <div class="airRowCombinedCell">
                            {{ value.y }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </horizontal-scrollbar>
                <div
                  class="airRowTimes"
                  id="airRowTimes2"
                  :style="rightColumnStyles"
                >
                  <div class="airRowButtons" v-if="!hideScrollButtons">
                    <v-btn v-on:click="scrollDataRight" outlined x-small>
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-btn v-on:click="scrollDataLeft" outlined x-small>
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </div>
                  <div class="airRowTitle">Время</div>
                  <div
                    v-for="(category, index) in data.charts[0].categories"
                    :key="index"
                    class="airRowTime"
                    :class="index == 0 && indicator == 'All' && 'first'"
                    :style="timeColumnStyles"
                  >
                    {{ drawTimeValues(category) }}
                  </div>
                </div>
              </div>
            </v-col>
            <v-row justify="center" v-if="chart_loading === true">
              <v-col justify="center"
                ><v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular></v-col
            ></v-row>
          </v-card-text>
        </v-card>
        <v-card
          outlined
          class="mt-2"
          :height="heightChart + 120"
          v-else-if="chart_loading === true"
        >
          <base-loader></base-loader>
        </v-card>
        <v-row
          v-else
          justify="center"
          class="mt-12"
          style="margin-left: 0; margin-right: 0"
        >
          <pre-report-mount />
        </v-row>
      </v-col>
    </v-row>
    <script
      defer
      type="application/javascript"
      :src="
        'https://js.onef.pro/static/reg1f_v1.js?1f_pixel_id=bb38ba5b-71c5-463f-b819-bf5757feaad3&event_type=visit&product=CompareTVPeriodReport&order_id=' +
        check_cookie_name('_ym_uid')
      "
    ></script>
    <preset-drawer
      report="compare-tv-period"
      v-if="!$route.params.uuid"
    ></preset-drawer>
  </v-container>
</template>
<style lang="scss">
.restoreSliderVals {
  color: rgba(25, 118, 210, 1);
  font-size: 15px;
  display: block;
  margin-top: 16px;
  margin-bottom: 4px;
}
.stickySliderBlock {
  position: sticky;
  top: 64px;
  z-index: 5;
  padding-top: 16px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.chartHelper {
  padding: 4px 16px 4px 8px;
  font-size: 15px;
  line-height: 28px;
  border-radius: 16px;
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.87);
  display: inline-block;
}
.chartHelper i {
  margin-top: -3px;
}

.scroll-me {
  min-width: 1000px;
}
$borderStyle: 1px solid rgba(0, 0, 0, 0.87);
// Надо как-то заполнить это из CONSTS ??
.c-1-color {
  background: rgba(241, 0, 0, 0.5);
}
.c-2-color {
  background: rgba(245, 135, 60, 0.5);
}
.c-3-color {
  background: rgba(251, 227, 149, 0.5);
}
.c-4-color {
  background: rgba(185, 210, 68, 0.5);
}
.c-5-color {
  background: rgba(54, 175, 75, 0.5);
}

.airRowTitle {
  height: 28px;
  line-height: 28px;
  width: 100%;
  background-color: #fff;
}
.airProgData {
  border: 1px solid white;
  border-radius: 4px;
  position: absolute;
  width: 126px;
  overflow: hidden;
  font-size: 14px;
  line-height: 20px;
  display: table;
}
.airProgData > div {
  max-width: 120px;
  padding: 2px;
  /*   word-wrap: normal; */
  text-align: center;
  display: table-cell;
  vertical-align: middle;
}
.airRowTimes {
  width: 109px;
  float: left;
  position: absolute;
  z-index: 4;
  background-color: #fff;
  height: 100%;
  top: 10px;
}
.airRowTimes button {
  width: 18px;
  height: 28px;
  // border: 1px solid black;
  background-color: #fff;
}
.airRowData {
  float: left;
  top: 10px;
}
.airRowProgs {
  float: left;
  width: 127px;
}
.airRowCombined {
  float: left;
  width: 198px;
}
.airRowValues {
  float: left;
  width: 97px;
  position: relative;
}
.airRowTimes .airRowTime {
  text-align: center;
  border-bottom: $borderStyle;
}
.airRowTime.first {
  border-top: $borderStyle;
}
.airRowTimes .airRowTitle {
  text-align: left;
  padding-left: 4px;
}
.airRowTimes .airRowButtons {
  position: absolute;
  left: -50px;
}
.airRowTimes .airRowButtons button {
  height: 28px !important;
  min-width: 24px !important;
}

.airRowProgs .airRowTitle {
  text-align: center;
}
.airRowCombined .airRowTitle {
  text-align: center;
  //border: $borderStyle;
}

.airRowCombinedBlock {
  display: table-row;
  border-bottom: $borderStyle;
  overflow: hidden;
}
.airRowCombinedBlock.first {
  border-top: $borderStyle;
}

.airRowCombinedCell {
  position: relative;
  width: 66px;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
}

.airRowCombinedCell:not(:first-child) {
  border-left: $borderStyle;
  border-collapse: collapse;
}
.airRowCombinedCell:last-child {
  border-right: $borderStyle;
}

.airRowValues div {
  text-align: right;
  padding-right: 6px;
}
.airRowValues .airRowTitle {
  text-align: center;
  left: -2px;
  position: relative;
  background-color: #fff;
  border-left: 1px solid #fff;
  width: 100px;
}

.airRowSubtitle div {
  width: 66px;
  text-align: center;
  float: left;
  font-size: 0.8em;
}
.popupBlockTitle {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
}
.popupBlockContent {
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-weight: bold;
  max-width: 500px;
}
.popupBlockContentBig {
  color: rgba(0, 0, 0, 1);
  font-size: 24px;
  font-weight: bold;
  max-width: 500px;
}
.popupBlockContentSmall {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;
  max-width: 500px;
}
</style>
<script>
import MainFilters from "@/components/MainFilters.vue";
import axios from "axios";
import moment from "moment";
import html2canvas from "html2canvas";
import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";
import wNumb from "wnumb";
import HorizontalScrollbar from "vue2-scrollbar";
import uuidv4 from "uuid/v4";
import BaseLoader from "@/components/BaseLoader.vue";
import PresetDrawer from "@/components/PresetDrawer.vue";
import PreReportMount from "@/components/PreReportMount.vue";
import { CONSTS } from "../services/constants.js";
import Utils from "../services/utils";

require("../../src/scss/vue2-scrollbar.css");

export default {
  name: "CompareTVPeriod",
  components: {
    BaseLoader,
    MainFilters,
    HorizontalScrollbar,
    PresetDrawer,
    PreReportMount,
  },
  beforeDestroy() {
    const slider = document.getElementById("comparison_slider");
    slider.noUiSlider.destroy();
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    if (!this.hasPriv) return this.$router.push("/");
    window.addEventListener("resize", this.handleResize, true);

    if (this.$route.params.uuid) {
      this.chart_loading = true;
      this.chartWithUuid();
    }
  },
  methods: {
    async hideTip() {
      await this.$store.dispatch("saveSettings", {
        compare_period_tip_closed: 1,
      });
    },
    initSlider() {
      const slider = document.getElementById("comparison_slider");
      noUiSlider.create(slider, {
        start: CONSTS.TV_COMPARE_SLIDER_RANGES,
        margin: 1,
        connect: [true, true, true, true, true],
        orientation: "horizontal",
        behaviour: "tap-drag",
        step: 1,
        tooltips: true,
        format: wNumb({
          decimals: 0,
          suffix: "%",
          edit: function (value) {
            if (parseInt(value) > 0) {
              value = "+" + value;
            }
            return value;
          },
        }),
        range: {
          min: -100,
          max: 100,
        },
      });
      var connect = slider.querySelectorAll(".noUi-connect");
      var classes = [
        "c-1-color",
        "c-2-color",
        "c-3-color",
        "c-4-color",
        "c-5-color",
      ];

      for (let i = 0; i < connect.length; i++) {
        connect[i].classList.add(classes[i]);
      }

      slider.noUiSlider.on("update", (values) => {
        values.forEach((item, i) => {
          this.ranges[i] = parseInt(item);
        });
        this.$forceUpdate();
      });
    },
    restoreSliderVals() {
      const slider = document.getElementById("comparison_slider");
      slider.noUiSlider.set(CONSTS.TV_COMPARE_SLIDER_RANGES);
    },
    async chartWithUuid() {
      console.log(this.$route.params.uuid);
      if (!this.$route.params.uuid) return;
      this.chart_loading = true;
      let res = await axios
        .post(`result/${this.$route.params.uuid}`)
        .catch(function () {
          this.chart_loading = null;
          this.isStoped = true;
          alert("Произошла ошибка");
        });
      if (res.data.message == "not ready") {
        this.reportRequest = res.data.request;
        setTimeout(() => {
          if (!this.isStoped) this.chartWithUuid();
        }, 1000);
        return;
      }

      if (this.isStoped) return;
      this.reportRequest = res.data.request;
      this.reportTime = moment().format("DD.MM.YYYY HH:mm:ss");
      this.reportUuid = this.$route.params.uuid;
      console.log(this.reportRequest);
      this.report = res.data.request["report"];
      this.selectedCityId = res.data.request["geo"];
      this.selectedChannelsIds = res.data.request["tv"]?.split(",");
      this.selectedSourceId = res.data.request["source_id"];
      this.helper = res.data.request["helper"];
      this.coef = res.data.request["useCoeff"];
      this.indicator = res.data.request["indicator"];
      this.manytv = res.data.request["manytv"];
      this.aggregate = res.data.request["aggregate"];
      this.detalisation = res.data.request["detalisation"];
      this.range.through = res.data.request["through"] == true;
      this.range.weekdays = res.data.request["weekdays"].split(",");
      this.range.start = `${res.data.request.startDate}T${res.data.request.startTime}:00.000`;
      this.range.end = `${res.data.request.endDate}T${res.data.request.endTime}:00.000`;
      this.chart_loading = false;

      this.data = res.data.result;
      this.data.load = true;
      this.contentWidth = document.getElementById("content_card")?.clientWidth;
      this.avgValue = this.data.avg;
      this.data.charts.forEach((chart) => {
        chart.series[0].maxY = 0.000001;
        chart.series[0].data.forEach((item) => {
          if (item.y > chart.series[0].maxY) chart.series[0].maxY = item.y;
        });
      });
      this.contentShift = 0;
      this.calcWidths();
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
        this.initSlider();
      });
    },
    drawProgDates(prog) {
      const sdt = prog.prog.start_loc;
      const edt = prog.prog.stop_loc;

      const sdate = moment(sdt, "YYYY-MM-DD HH:mm:ss").format("DD.MM.YYYY");
      const edate = moment(edt, "YYYY-MM-DD HH:mm:ss").format("DD.MM.YYYY");

      if (sdate != edate) {
        return `${moment(sdt, "YYYY-MM-DD HH:mm:ss").format("DD.MM.YYYY HH:mm")}
               - ${moment(edt, "YYYY-MM-DD HH:mm:ss").format(
                 "DD.MM.YYYY HH:mm"
               )}
              `;
      }

      return `${moment(sdt, "YYYY-MM-DD HH:mm:ss").format("DD.MM.YYYY HH:mm")}
              - ${moment(edt, "YYYY-MM-DD HH:mm:ss").format("HH:mm")}`;
    },
    drawRowDate(dt) {
      return `${moment(dt, "DD.MM.YYYY").locale("ru").format("dd")}, ${dt}`;
    },
    toggleScrolls() {
      if (this.dataWidth >= this.contentWidth - 180) {
        this.hideScrollButtons = false;
        // console.log("part");
      } else {
        this.hideScrollButtons = true;
        //  console.log("full");
      }
    },
    calcWidths() {
      if (!this.data?.charts?.length) return (this.dataWidth = 0);
      this.columnWidth = this.showValues * 97 + 127;
      if (this.indicator === "All") this.columnWidth = this.combinedColumnWidth;
      this.dataWidth = this.data.charts.length * this.columnWidth + 108;
    },
    scrollDataLeft() {
      this.$refs.contentScrollbar.scrollToX(
        this.$refs.contentScrollbar.left + this.columnWidth
      );
    },
    scrollDataRight() {
      this.$refs.contentScrollbar.scrollToX(
        this.$refs.contentScrollbar.left - this.columnWidth
      );
    },
    handleResize() {
      this.contentWidth = document.getElementById("content_card")?.clientWidth;
      if (this.$refs.contentScrollbar) this.$refs.contentScrollbar.scrollToX(0);
    },
    getBackgroundForProg(prog) {
      //console.log(prog, this.ranges, this.contentWidth);
      if (prog.dev <= this.ranges[0] / 100)
        return CONSTS.TV_COMPARE_SLIDER_COLORS[0];
      if (prog.dev <= this.ranges[1] / 100)
        return CONSTS.TV_COMPARE_SLIDER_COLORS[1];
      if (prog.dev <= this.ranges[2] / 100)
        return CONSTS.TV_COMPARE_SLIDER_COLORS[2];
      if (prog.dev <= this.ranges[3] / 100)
        return CONSTS.TV_COMPARE_SLIDER_COLORS[3];
      return CONSTS.TV_COMPARE_SLIDER_COLORS[4];
    },
    getProgStyle(prog, row, column) {
      column;
      let top = 0;
      let bottom = 60 * 24;
      let reportDate;
      const startDate = prog.prog.start_loc.substring(0, 10);
      const stopDate = prog.prog.stop_loc.substring(0, 10);
      if (row == 0) {
        reportDate = stopDate;
      } else {
        reportDate = startDate;
      } //tmp

      if (startDate == reportDate) {
        const [h, m] = prog.prog.start_loc_time.split(":");
        top = h * 60 + +m;
      }
      if (stopDate == reportDate) {
        const [h, m] = prog.prog.stop_loc_time.split(":");
        bottom = 1 + h * 60 + +m;
      }

      top = (top * this.cellHeight) / 15 + 28;
      bottom = (bottom * this.cellHeight) / 15 + 28;

      let height = bottom - top;

      //console.log(prog, top, bottom, height)
      const color = this.getBackgroundForProg(prog);
      prog.style = `top: ${top + 1}px; height:${height - 2}px; max-height:${
        height - 2
      }px; background-color: ${color};`;
      prog.height = height;
      return prog.style;
    },

    getValuesStyles(value, row) {
      value.dev = (value.y_tvr - this.avgValue) / this.avgValue;
      const color = this.getBackgroundForProg(value);
      return `height: ${this.cellHeight}px; line-height: ${
        this.cellHeight
      }px; top: ${
        this.cellHeight * (row + 1) - 4 + 22
      }px; background-color: ${color};`;
    },

    drawTimeValues(str) {
      let [h, m] = str.split(":");
      str += ` - ${h}:${+m + 14}`;
      return str;
    },
    exportBtnClick(e) {
      switch (e) {
        case "png":
          this.saveChartToPng();
          break;
        case "svg":
          break;

        case "pdf":
          break;

        default:
          //xls
          this.toExcel();
          break;
      }
    },
    stopCube() {
      this.chart_loading = null;
      this.isStoped = true;
      this.axiosCancel();
    },
    async saveChartToPng() {
      const canvas = await html2canvas(
        document.querySelector(`#highcharts_png`)
      );
      Utils.saveAs(canvas.toDataURL(), `${this.filename}.png`);
    },
    async toExcel() {
      const start = moment(this.range.start).locale("ru").format("DD.MM.YYYY");
      const end = moment(this.range.end).locale("ru").format("DD.MM.YYYY");
      const startTime = moment(this.range.start).locale("ru").format("HH:mm");
      const endTime = moment(this.range.end).locale("ru").format("HH:mm");
      const city = this.cities.find((el) => {
        return el.id === this.selectedCityId;
      });

      const source = this.sources.find((el) => {
        return el.id === this.selectedSourceId;
      });

      const channels = this.channels.filter((el) => {
        return this.selectedChannelsIds.includes(el.id);
      });

      //console.log(source, city, channels)

      const jsonArray = {
        data: this.data,
        ranges: this.ranges,
      };
      const params = [
        "Id отчета: " + this.reportUuid,
        "Время: " + this.reportTime,
        "Период: " + `${start} ${startTime} - ${end} ${endTime}`,
        "Дни недели: " + this.range.weekdays.sort(),
        "Вычисление периода: " + this.range.through,
        "Источник: " + source.name,
        "Справочник: " + this.helper,
        "Коэффициенты: " + this.coef,
        "Регион: " + city.name,
      ];

      if (channels.length > 1) {
        params.push(
          `Телеканалы: ${channels.map((item) => item.export_name).join(", ")}`
        );
      } else {
        if (channels.length === 1)
          params.push(`Телеканал: ${channels[0].export_name}`);
      }
      const req = {
        jsonArray,
        params,
        reportName: this.reportName,
        indicator: this.indicator,
      };
      const response = await axios.post("jsonToExcel", req, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${this.filename}.xlsx`);
      document.body.appendChild(link);
      link.click();
    },
    copyToClipboard(containerid) {
      var range = document.createRange();
      let containerNode = document.getElementById(containerid); //// this part
      range.selectNode(containerNode); //// this part
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      alert("Данные скопированы");
    },
    async cubeData(req) {
      this.isStoped = false;
      this.data = {};
      this.multiCount = 1;
      this.reportUuid = uuidv4();
      this.reportTime = moment().format("DD.MM.YYYY HH:mm:ss");
      req.set("uuid", this.reportUuid);
      req.set("detalisation", 15);
      req.set("report_type", "hour");
      req.set("aggregate", "Day");
      req.set("requestedReport", this.reportName);
      this.isMulti = false;
      this.tvForAccent = [req.get("tv")];
      this.chart_loading = true;
      let cubeObj = {};
      req.forEach(function (value, key) {
        cubeObj[key] = value;
      });
      cubeObj["email"] = this.$store.getters.StateUser.email;

      cubeObj["action"] = "MakeReport";
      // eslint-disable-next-line no-undef
      let reportUniqid = Utils.generateUID();
      cubeObj["uniqid"] = reportUniqid;
      cubeObj["uid"] = this.$store.getters.StateUser.uid;
      cubeObj["ym_uid"] = this.check_cookie_name("_ym_uid");
      // eslint-disable-next-line no-undef
      if (process.env.VUE_APP_ALTERNATE_UI != "true") mh_px(300, cubeObj);
      // eslint-disable-next-line no-unused-vars
      let timeReq = performance.now();
      const CancelToken = axios.CancelToken;
      let that = this;
      let res = await axios
        .post("reports/cubedata", req, {
          cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            that.axiosCancel = c;
          }),
        })
        .catch(function () {
          this.chart_loading = null;
          this.isStoped = true;
          alert("Произошла ошибка");
        });
      if (res.data.message === "The report has been queued") {
        this.reportRequest = res.data.request;
        // window.location.href = this.$route.path + "/" + res.data.uuid;
        this.$router.push(this.$route.path + "/" + res.data.uuid);
        this.chartWithUuid();
        return;
      }
      if (this.isStoped) return;

      this.report = req.get("report_type");
      this.selectedCityId = req.get("geo");
      this.selectedChannelsIds = req.get("tv")?.split(",");
      this.selectedSourceId = req.get("source_id");
      this.helper = req.get("helper");
      this.coef = req.get("useCoeff");
      this.chart_loading = false;
      timeReq = performance.now() - timeReq;
      if (process.env.VUE_APP_ALTERNATE_UI != "true")
        // eslint-disable-next-line no-undef
        mh_px(300, {
          uniqid: reportUniqid,
          action: "DataReport",
          // email: this.$store.getters.StateUser.email,
          uid: this.$store.getters.StateUser.uid,
          msecs: timeReq,
        });
      this.indicator = req.get("indicator");
      this.manytv = req.get("manytv");
      this.aggregate = req.get("aggregate");
      this.detalisation = req.get("detalisation");
      this.data = res.data;
      this.data.load = true;
      this.contentWidth = document.getElementById("content_card")?.clientWidth;
      //console.log(this.data);
      this.avgValue = this.data.avg;
      this.data.charts.forEach((chart) => {
        chart.series[0].maxY = 0.000001;
        chart.series[0].data.forEach((item) => {
          if (item.y > chart.series[0].maxY) chart.series[0].maxY = item.y;
        });
      });
      this.contentShift = 0;
      this.calcWidths();
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
        this.initSlider();
      });
    },
  },
  data: () => ({
    reportRequest: {},
    axiosCancel: null,
    reportName: "compare-tv-period",
    avgValue: 1,
    hideScrollButtons: true,
    contentShift: 0,
    contentWidth: 0,
    columnWidth: 0,
    dataWidth: 0,
    rightColumnPos: 0,
    ranges: [-30, -11, 11, 30],
    cellHeight: 32,
    combinedColumnWidth: 66 * 3,
    showValues: false,
    toggle_graphType: 0,
    selectedCityId: null,
    selectedSourceId: null,
    selectedChannelsIds: [],
    range: {},
    tableSearch: "",
    report: null,
    isMulti: false,
    detalisation: 1,
    aggregate: null,
    multiCount: 1,
    visionType: "graph",
    isStoped: false,
    allProgramms: [],
    data: {},
    manytv: false,
    indicator: "",
    chart_loading: null,
    cities: [],
    channels: [],
    sources: null,
    pageData: {
      title: "Анализ программирования",
      type: "compare-tv-period",
      many_channel: false,
    },
  }),
  computed: {
    isAlternate() {
      return process.env.VUE_APP_ALTERNATE_UI == "true";
    },
    hasPriv() {
      return !!this.$store.getters.StateUser.privs[
        CONSTS.PRIVS_KEYS.section_compare_tv_period
      ];
    },
    filename() {
      const city = this.cities.find((el) => {
        return el.id === this.selectedCityId;
      });

      const channels = this.channels.filter((el) => {
        return this.selectedChannelsIds.includes(el.id);
      });
      const shows = [];
      const filename = Utils.createFilename({
        range: this.range,
        cities: city,
        channels: channels,
        shows: shows,
        indicator: this.chartTitle,
        reportTime: this.reportTime,
      });
      return filename;
    },
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    subtitle() {
      let start = moment(this.range.start).locale("ru").format("DD MMM YYYY");
      let end = moment(this.range.end).locale("ru").format("DD MMM YYYY");
      let startTime = moment(this.range.start).locale("ru").format("HH:mm");
      let endTime = moment(this.range.end).locale("ru").format("HH:mm");
      let city = this.cities.find((el) => {
        return el.id === this.selectedCityId;
      });
      return `${city.name}, ${start} - ${end}, ${startTime} - ${endTime}`;
    },
    tableHeaders() {
      if (this.isMulti) {
        let headers = [
          {
            text: "№",
            value: "num",
            visible: true,
          },
          {
            text: "Дата",
            value: "date",
            visible: this.report === "hour" ? this.aggregate === "Day" : false,
          },
          {
            text:
              this.report === "hour"
                ? "Время"
                : this.manytv === "true"
                ? "Канал"
                : "Период",
            value: "time",
            visible: true,
          },
        ];

        if (this.data.charts.length) {
          for (let i = 0; i < this.data.charts[0].series.length; i++) {
            headers.push({
              text: this.data.charts[0].series[i].name,
              value: "y" + i,
              visible: true,
            });
          }
        }

        return headers.filter((el) => {
          return el.visible;
        });
      }

      if (this.indicator === "All") {
        return [
          {
            text: "№",
            value: "num",
            visible: true,
          },
          {
            text: "Канал",
            value: "channel",
            visible: true,
          },
          {
            text: this.chartTitle,
            value: "aud",
            visible: true,
          },
          {
            text: "Доля, %",
            value: "share",
            visible: true,
          },
          {
            text: "Рейтинг",
            value: "tvr",
            visible: true,
          },
          {
            text: "Охват, тыс. телезрителей",
            value: "reach",
            visible: true,
          },
          {
            text: "Охват, %",
            value: "reachPercent",
            visible: true,
          },
        ];
      }

      let headers = [
        {
          text: "№",
          value: "num",
          visible: true,
        },
        {
          text: "Дата",
          value: "date",
          visible: this.report === "hour" ? this.aggregate === "Day" : false,
        },
        {
          text:
            this.report === "hour"
              ? "Время"
              : this.manytv === "true"
              ? "Канал"
              : "Период",
          value: "time",
          visible: true,
        },
        {
          text: this.chartTitle,
          value: "y",
          visible: true,
        },
      ];
      if (this.indicator === "AudienceDemo") {
        headers[headers.length - 1]["text"] = "Мужчины";
        headers.push({
          text: "Женщины",
          value: "y2",
          visible: true,
        });
      }

      return headers.filter((el) => {
        return el.visible;
      });
    },
    heightChart() {
      let h = 400;
      if (this.data && this.data.charts && this.data.charts.length) {
        h = this.data.charts[0].categories.length * this.cellHeight + 28 + 10;
      }
      return h;
    },
    progsColumnStyles() {
      let height = this.heightChart;
      if (this.indicator === "All") height += 22;
      return `height: ${height}px; background-color: white; z-index:3; position: relative;`;
    },
    timeColumnStyles() {
      let top = 0;
      if (this.indicator === "All") top = 22;
      return `height: ${this.cellHeight}px; line-height: ${this.cellHeight}px; top: ${top}px; position:relative;`;
    },
    contentBlockStyles() {
      let height = this.heightChart;
      if (this.indicator === "All") height += 22;
      return `height: ${height}px; position: relative; width: ${
        this.contentWidth - 71
      }px; overflow: hidden;`;
    },
    rightColumnStyles() {
      let visibleDataWidth = this.dataWidth;
      if (visibleDataWidth >= this.contentWidth - 180) {
        visibleDataWidth = this.contentWidth - 180;
      }
      if (this.isMobile) return `display: none; `;
      return `position: absolute; z-index: 3; left: ${visibleDataWidth}px; background-color:#fff;`;
    },
    mainColumnStyles() {
      let height = this.heightChart;
      let width = this.dataWidth + 1;
      if (this.indicator === "All") height += 22;
      if (!this.isMobile) width += 107;
      return `float: left; width: ${width}px; padding-left: 108px; height: ${height}px; overflow: hidden`;
    },
    dataColumnStyles() {
      return `width: ${this.columnWidth}px; float: left; position: relative; left: ${this.contentShift}px`;
    },
    chartTitle() {
      let title = "Показатель";
      switch (this.indicator) {
        case "Watchtime":
          title = "Время просмотра, с";
          break;
        case "UuidCount":
          title = "Уникальные устройства за час, шт.";
          break;
        case "SanCount":
          title = "Уникальные домохозяйства за час, шт.";
          break;
        case "UuidCountDay":
          title = "Уникальные устройства за сутки, шт.";
          break;
        case "SanCountDay":
          title = "Уникальные домохозяйства за сутки, шт.";
          break;
        case "Audience":
          title = "Аудитория, тыс.";
          break;
        case "All":
          title = "Аудитория, тыс.";
          break;
        case "AudienceDemo":
          title = "Аудитория, тыс.";
          break;
        case "TVR":
          title = "Рейтинг";
          break;
        case "TVRTotal":
          title = "Рейтинг общий";
          break;
        case "Share":
          title = "Доля, %";
          break;
        case "Reach":
          title = "Охват, тыс. чел.";
          break;
        case "ReachPercent":
          title = "Охват, %";
          break;
      }
      return title;
    },
  },
  watch: {
    dataWidth() {
      this.toggleScrolls();
    },
    contentWidth() {
      this.toggleScrolls();
    },
    showValues() {
      this.calcWidths();
      setTimeout(() => window.dispatchEvent(new Event("resize")));
    },
    indicator() {
      this.calcWidths();
      if (this.indicator === "All") {
        this.toggle_graphType = 1;
        // element.style.visibility = "hidden";
      } else {
        //element.style.visibility = "visible";
      }
    },
    toggle_graphType() {
      this.visionType = this.toggle_graphType === 0 ? "graph" : "table";
    },
  },
};
</script>
